import { DateTime } from "luxon"

import { getFlowChartData } from "@/features/dashboards/api/BCO/getFlowChartData.ts"
import { getGasChartData } from "@/features/dashboards/api/BCO/getGasChartData.ts"
import Dashboard from "@/features/dashboards/components/Dashboard"
import type { KPIGroupRequest } from "@/types/kpiTypes.ts"

export default function BCO() {
  const gasMetricsConfig: KPIGroupRequest = {
    aggType: "Monthly",
    asOf: DateTime.now().startOf("day").toJSDate(),
    returnSize: 6,
    kpis: [
      {
        $type: "calc",
        name: "Raw Inlet Gas per Minute",
        unit: "SCFM",
        expression: "[60] / 1.44",
        aggFunction: "Average",
        location: 2,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 60,
        typeId: 1,
        location: 2,
      },
      {
        $type: "basic",
        id: 65,
        typeId: 1,
        location: 2,
      },
      {
        $type: "basic",
        id: 61,
        typeId: 1,
        location: 2,
      },
      {
        $type: "calc",
        name: "Uptime",
        unit: "%",
        aggFunction: "Average",
        location: 2,
        typeId: 1,
        expression: "[110]/24*100",
      },
      {
        $type: "calc",
        name: "Efficiency",
        unit: "%",
        aggFunction: "Average",
        location: 2,
        typeId: 1,
        preAggregate: true,
        expression: "[80] / ([61] * ([110] / 24)) * 100",
      },
      { $type: "basic", id: 80, location: 2, typeId: 1 },
      { $type: "basic", id: 70, location: 2, typeId: 1 },

      {
        $type: "calc",
        expression: "[50] * 0.6 + [55]",
        unit: "MMBtu",
        name: "Gas Flared",
        aggFunction: "Sum",
        typeId: 1,
        location: 2,
      },
    ],
  }

  return (
    <Dashboard
      config={{
        kpiTable: {
          request: gasMetricsConfig,
          paddingArray: [16, 16, 32, 16, 32, 32, 16, 16, 16],
        },
        rollingChart: {
          totalDays: 180,
          averageDays: 7,
          primaryKPIs: [
            { $type: "basic", id: 61, location: 2, typeId: 1 },
            {
              $type: "basic",
              id: 80,
              location: 2,
              typeId: 1,
            },
          ],
          secondaryKPI: {
            $type: "calc",
            expression: "[10] + [20]",
            name: "Manure Received",
            unit: "Gallons",
            location: 2,
            typeId: 1,
          },
        },
        flowChart: {
          fetcher: getFlowChartData,
          location: 2,
        },
        gasChart: {
          fetcher: getGasChartData,
          location: 2,
        },
        chartGroup: {
          returnSize: 10,
          aggType: "Weekly",
          asOf: DateTime.now()
            .setZone("America/Chicago")
            .startOf("week")
            .minus({ days: 1 })
            .toJSDate(),
          kpis: [
            {
              $type: "basic",
              id: 45,
              location: 2,
            },
            {
              $type: "calc",
              expression: "([10]+[20])/[45] * 100",
              name: "% Raw Manure to Digesters",
              preAggregate: true,
              aggFunction: "Average",
              unit: "%",
              location: 2,
            },
            {
              $type: "basic",
              id: 80,
              location: 2,
            },
            {
              $type: "calc",
              expression: "[110]/24*100",
              name: "Plant Uptime",
              aggFunction: "Average",
              unit: "%",
              location: 2,
            },
          ],
        },
      }}
    />
  )
}
